export default "__VITE_ASSET__DRgaymT$__"